import React from 'react';
import { Toaster } from './ui/sonner';
import { UpdateToast } from './UpdateToast';
import MfaStepUpModal from './MfaStepUpModal';
import { useCustomerPresentation } from '../contexts/CustomerPresentationContext';

export default function AppOverlays() {
  const { presenting } = useCustomerPresentation();
  // Unmount the notification surface, including future toasts, while the screen
  // is handed to a customer. Hiding/dismissing existing toast text is insufficient.
  if (presenting) return null;
  return <><Toaster position="top-center" /><MfaStepUpModal /><UpdateToast /></>;
}
